export const SALUTATION_MR: string = 'customer.salutation.mr'
export const SALUTATION_MRS: string = 'customer.salutation.mrs'
